'use client';

import { ThemeProvider } from 'next-themes';
import { usePathname } from 'next/navigation';
import { PostHogProvider } from '@/lib/posthog';

export function AppProviders({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();

  if (pathname?.startsWith('/embed/')) {
    return <>{children}</>;
  }

  return (
    <PostHogProvider>
      <ThemeProvider
        attribute="class"
        defaultTheme="system"
        enableSystem
        disableTransitionOnChange
      >
        {children}
      </ThemeProvider>
    </PostHogProvider>
  );
}
